import React from "react";
import PropTypes from "prop-types";
import { StyleRoot } from "radium";
import PageHeader from "backpack-ui/dist/components/pageHeader";
import ContentHeader from "../pois/components/contentHeader";
import Amenities from "../pois/components/amenities";

function HomeComponent() {
  const links = [
    "<a href='/things-to-do/1247462'>Ryman Auditorium</a>",
    "<a href='/a/poi-sig/362079'>New York City Sights</a>",
    "<a href='/a/poi-sig/362494/'>Melbourne Sights</a>",
    "<a href='/a/poi-sig/362228/'>Nashville Sights</a>",
    "<a href='/a/poi-sig/359279/'>Paris Sights</a>",
    "<a href='/a/poi-sig/356817/'>Tokyo Sights</a>",
    "<a href='/a/poi-sig/361858/'>San Fransisco</a>",
  ];

  return (
    <StyleRoot>
      <div className="PageContainer HomeComponent">
        <PageHeader
          heading="Dotcom POIs"
          title="Rendering POIs since 2016"
          alignment="center"
          contained
        />

        <section className="ContentSection">
          <ContentHeader
            title="Pages"
            heading={{
              level: 4,
              size: "tiny",
              weight: "thick",
              importance: "high",
              caps: true,
            }}
            border="bottom"
          />

          <Amenities
            listType="single"
            columns={1}
            items={links}
          />
        </section>
      </div>
    </StyleRoot>
  );
}

HomeComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default HomeComponent;


// WEBPACK FOOTER //
// ./assets/home/home.jsx